'use client';

import BaseHeader from '../../../../../components/header/Header';
import MagicBar from '../commons/MagicBar';
import NavBar from '../commons/NavBar';
import FilterBar from './filter/FilterBar';

export default function Header() {
  return (
    <BaseHeader
      renderCenter={
        <div className="hidden md:block">
          <MagicBar />
        </div>
      }
      renderBottom={
        <>
          <div className="block md:hidden space-y-3">
            <div className="container mx-auto px-4">
              {<MagicBar />}
            </div>
            {<FilterBar />}
          </div>
          <div className="hidden md:block">
            <NavBar />
          </div>
        </>
      }
    />
  );
}
